/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosports3ColumnImagesViewProps } from './hosports-3-column-images';

export default (props: IHosports3ColumnImagesViewProps) => {
    return (
        <h2>{'hosports-three-column-images-view'}</h2>
    );
};
